import { Button, Flex, Form, Modal } from 'antd';
import FranchisorsForm from '../form';
import { Franchise } from '@/types';
import { useEffect } from 'react';

interface Props {
  open: boolean;
  onCancel: () => void;
  handleFinish: (values: any) => void;
  currentFranchisor?: Partial<Franchise>;
  loading: boolean;
}

export default function EditUserModal({
  open,
  onCancel,
  handleFinish,
  loading,
  currentFranchisor,
}: Props): JSX.Element {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(currentFranchisor);
  }, [form, currentFranchisor]);

  return (
    <Modal
      title={'Edit User'}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={460}
      centered
    >
      <FranchisorsForm handleFinish={handleFinish} form={form} />
      <Flex gap={12}>
        <Button
          onClick={() => form.submit()}
          type={'primary'}
          className={'admin-button-download-table'}
          style={{
            paddingInline: '32px',
            width: '100%',
          }}
          disabled={loading}
        >
          Save
        </Button>

        <Button
          type={'default'}
          onClick={onCancel}
          style={{
            backgroundColor: 'white',
            color: '#1C8271',
            boxShadow: 'none',
            width: '100%',
            height: '40px',
            paddingInline: '32px',
          }}
        >
          Cancel
        </Button>
      </Flex>
    </Modal>
  );
}
